import axios from 'axios';
import { baseUrl } from "../utilities/config";

export const getEducationInformation = (url) => {
  let config = {
    method: 'get',
    url: `${baseUrl}${url}`,
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return axios(config)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export const postEducationInformation = (data, url) => {
  let config = {
    method: 'post',
    url: `${baseUrl}${url}`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: data
  };

  return axios(config)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}